<template>
  <div class="rule-of-trial wrap-content">
    <div class="wrap-inner">
      <div class="wrap-form">
        <label class="form-label">送审规则配置</label>
        <Form>
          <!--<FormItem>-->
            <!--<Row>-->
              <!--<Col span="5">.</Col>-->
              <!--<Col span="19">-->
                <!--<strong>针对不同学校要求按如下条件配置不同的送审规则：</strong>-->
              <!--</Col>-->
            <!--</Row>-->
          <!--</FormItem>-->
          <FormItem>
            <Row>
              <Col span="1" style="width: 60px;">
                <label>学校：</label>
              </Col>
              <Col span="5">
                <Select style="width: 200px;" v-model="schoolSendRulesDTO.schoolId" filterable @on-change="changeSchool()">
                  <Option v-for="(item,index) in schoolList" :value="item.id" :key="index">{{ item.name }} ({{ item.code }})</Option>
                </Select>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="24">
                <CheckboxGroup v-model="rule"  v-for="(item,index) in ruleList" :key="index">
                  <Checkbox :label="item.id">
                    <span v-if="item.code === '2'">{{ item.code }} .实行评审专家回避原则，
                      <RadioGroup v-model="ruleOfTwo">
                        <Radio label="1">
                            <span>甲方所在单位  /</span>
                        </Radio>
                        <Radio label="2">
                            <span>甲方所在省内的高校专家</span>
                        </Radio>
                      </RadioGroup>
                      原则上不参加博士论文评审（在前面两项○中选择其中一个，必选）
                    </span>
                    <span v-else-if="item.code === '3'">{{ item.code }} .实行评审专家回避原则，
                      <RadioGroup v-model="ruleOfThree">
                        <Radio label="1">
                            <span>甲方所在单位  /</span>
                        </Radio>
                        <Radio label="2">
                            <span>甲方所在省内的高校专家</span>
                        </Radio>
                      </RadioGroup>
                      原则上不参加硕士论文评审（在前面两项○中选择其中一个，必选）
                    </span>
                    <span v-else>{{ item.code }} . {{ item.displayName }}</span>
                  </Checkbox>
                </CheckboxGroup>
              </Col>
            </Row>
          </FormItem>
        </Form>
        <Button type="primary" @click="saveConfig">保存配置</Button>
      </div>
    </div>
  </div>
</template>

<script>
// 送审规则
export default {
  name: 'ruleOfTrial',
  data () {
    return {
      // 选中的规则
      rule: [],
      // 第二个规则中选中的选项
      ruleOfTwo: '',
      // 第三个规则中选中的选项
      ruleOfThree: '',
      // 存储学校送审规则的对象
      schoolSendRulesDTO: {
        schoolId: '',
        list: []
      },
      // 学校（单位）列表
      schoolList: [],
      // 所有配置的规则列表
      ruleList: [],
      // 根据schoolId查询出的一个学校的规则集合
      ruleOfSchool: [],
      // 暂存学校规则id集合
      ruleCache: []
    }
  },
  created () {
    this.querySchoolList();
    this.queryRuleList();
  },
  activated () {
    this.querySchoolList();
    this.queryRuleList();
  },
  methods: {
    // 查询学校列表
    querySchoolList () {
      this.fetch('/school/school/querySchoolList', {keyWord: ''}).then(res => {
        this.schoolList = res.data;
      });
    },
    // 查询所有规则
    queryRuleList () {
      this.post('school/schoolSendRulesInfo/all').then(res => {
        this.ruleList = res.data;
      });
    },
    // 下拉选修改学校触发事件
    changeSchool () {
      this.fetch('/school/school/sendRules/' + this.schoolSendRulesDTO.schoolId).then(res => {
        this.ruleOfSchool = [];
        this.ruleOfSchool = res.data;
        let code = '';
        this.ruleOfTwo = '';
        this.ruleOfThree = '';
        this.rule = [];
        this.ruleOfSchool.forEach(item => {
          code = (this.ruleList.filter(data => data.id === item.sendRulesId))[0].code;
          if (code === '2') {
            this.ruleOfTwo = item.remark;
            this.rule.push(item.sendRulesId);
          } else if (code === '3') {
            this.ruleOfThree = item.remark;
            this.rule.push(item.sendRulesId);
          } else {
            this.rule.push(item.sendRulesId);
          }
        });
      });
    },
    // 保存配置
    saveConfig () {
      let msg = true;
      let code = '';
      if (this.schoolSendRulesDTO.schoolId) {
        this.schoolSendRulesDTO.list = [];
        this.rule.forEach(item => {
          code = (this.ruleList.filter(data => data.id === item))[0].code;
          if (code === '2') {
            if (this.ruleOfTwo) {
              this.schoolSendRulesDTO.list.push({
                schoolId: this.schoolSendRulesDTO.schoolId,
                sendRulesId: item,
                remark: this.ruleOfTwo
              });
            } else {
              msg = false;
              return false;
            }
          } else if (code === '3') {
            if (this.ruleOfThree) {
              this.schoolSendRulesDTO.list.push({
                schoolId: this.schoolSendRulesDTO.schoolId,
                sendRulesId: item,
                remark: this.ruleOfThree
              });
            } else {
              msg = false;
              return false;
            }
          } else {
            this.schoolSendRulesDTO.list.push({
              schoolId: this.schoolSendRulesDTO.schoolId,
              sendRulesId: item
            });
          }
        });
        if (msg) {
          this.post('school/school/SaveSendRules', this.schoolSendRulesDTO).then(res => {
            if (res.code === 200) {
              this.$Message.success('保存成功');
            }
          })
        } else {
          this.$Message.error('第二项或者第三项未选择其中的内容！');
        }
      } else {
        this.$Message.error('请选择学校！');
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/layout/customPage/configManage/ruleOfTrial.vue